const common = {
  back: 'Back',
  edit: 'Edit',
  remove: 'Remove',
  error: 'Something went wrong. Please try again.',
  badges: {
    falIndividual: 'Individual (Safaqat24 license)',
  },
  common: {
    loading: 'Loading...',
    signIn: 'Sign in',
  },
  // Generic UI labels used in multiple places (e.g. table headers).
  name: 'Name',
  email: 'Email',
  role: 'Role',
  you: 'You',
  tableView: 'Table View',
  cardView: 'Card View',
  signin_to_save_favorites: 'Sign in to save your favorites',
  brand: {
    name: 'Safaqat 24',
    tagline: 'Your Trusted Real Estate Platform',
  },
  navigation: {
    home: 'Home',
    search: 'Find Homes',
    consultation: 'Book Consultation',
    create: 'List Property',
    subscriptions: 'Subscriptions',
    contact: 'Contact Us',
    trustedBrokers: 'Trusted Brokers',
    clientRequests: 'Property Requests',
    dashboard: 'Dashboard',
    listProperty: 'List Property',
    postRequest: 'Post Request',
    profile: 'My Profile',
    settings: 'Settings',
    services: 'Services',
    myComplaints: 'My Complaints',
    companyDashboard: 'Company Dashboard',
    teamManagement: 'Team Management',
    registerCompany: 'Register Company',
    enquiries: 'Enquiries',
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
    sidebar: {
      guest: 'Guest',
      navigation: 'Navigation',
      account: 'Account',
      quickActions: 'Quick Actions',
      accountSettings: 'Account Settings',
      myAds: 'My Ads',
      licenses: 'Licenses',
      myRequests: 'My Requests',
      bookingHistory: 'Booking History',
      addProperty: 'Add Property',
      bookConsultation: 'Book Consultation',
      subscriptions: 'Subscriptions',
      favorites: 'My Favorites',
      trustedBrokers: 'Trusted Brokers',
      submitRequest: 'Submit Property Request',
      brokerRequests: 'Client Requests',
      authorizeProperty: 'Authorize Property',
      aboutUs: 'About Us',
      complaints: 'Submit Complaint',
      dashboard: 'Dashboard',
      services: 'Services',
      myListings: 'My Listings',
      postRequest: 'Post a Request',
    },
  },
  auth: {
    join: 'Join Today',
    signIn: 'Sign In',
    signUp: 'Create Account',
    signOut: 'Sign Out',
    settings: 'Account Settings',
    loadingTitle: 'Loading your experience...',
    loadingSubtitle: 'Please wait while we prepare the latest listings.',
    // Modal & Page Titles
    signInTitle: 'Sign In',
    signUpTitle: 'Create Account',
    welcomeBack: 'Welcome Back',
    signInSubtitle: 'Sign in to your Safaqat 24 account',
    createAccountTitle: 'Create Your Account',
    createAccountSubtitle: 'Join Safaqat 24 to find your perfect property',
    resetPasswordTitle: 'Reset Password',
    resetPasswordSubtitle: 'Enter your email address and we\'ll send you a link to reset your password.',
    // Form Labels
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    required: '*',
    // Placeholders
    enterFirstName: 'Enter your first name',
    enterLastName: 'Enter your last name',
    enterEmail: 'Enter your email',
    enterPassword: 'Enter your password',
    createPassword: 'Create a strong password',
    confirmYourPassword: 'Confirm your password',
    // Buttons & Actions
    signingIn: 'Signing In...',
    creatingAccount: 'Creating Account...',
    sending: 'Sending...',
    sendResetLink: 'Send Reset Link',
    cancel: 'Cancel',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot your password?',
    backToHome: 'Back to Home',
    // Links & Toggles
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    signUpFree: 'Sign up for free',
    signInHere: 'Sign in here',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    closeModal: 'Close authentication modal',
    // Helper Text
    passwordRequirements: 'Must be at least 8 characters with uppercase, lowercase, and number',
    agreeToTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    byCreatingAccount: 'By creating an account, you agree to our',
    // Success Messages
    signInSuccess: 'Successfully signed in! Welcome back.',
    signUpSuccess: 'Account created successfully! Please check your email to verify your account.',
    signUpSuccessRedirect: 'Account created successfully! Please check your email to verify your account before signing in.',
    verifyEmailMessage: 'Please check your email and verify your account to continue.',
    passwordResetSent: 'Password reset email sent! Please check your inbox.',
    redirecting: 'Redirecting...',
    // Error Messages
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    emailTooLong: 'Email must be less than 100 characters',
    passwordRequired: 'Password is required',
    passwordTooShort: 'Password must be at least 8 characters long',
    passwordTooLong: 'Password must be less than 128 characters',
    passwordWeak: 'Password must contain at least one uppercase letter, one lowercase letter, and one number',
    confirmPasswordRequired: 'Please confirm your password',
    passwordsMismatch: 'Passwords do not match',
    firstNameRequired: 'First name is required',
    firstNameTooShort: 'First name must be at least 2 characters long',
    firstNameTooLong: 'First name must be less than 50 characters',
    firstNameInvalid: 'First name can only contain letters (English or Arabic), spaces, hyphens, and apostrophes',
    lastNameRequired: 'Last name is required',
    lastNameTooShort: 'Last name must be at least 2 characters long',
    lastNameTooLong: 'Last name must be less than 50 characters',
    lastNameInvalid: 'Last name can only contain letters (English or Arabic), spaces, hyphens, and apostrophes',
    termsRequired: 'You must agree to the Terms of Service and Privacy Policy',
    emailForReset: 'Please enter your email address first',
    // API Error Messages
    invalidCredentials: 'Invalid email or password. Please check your credentials.',
    emailNotConfirmed: 'Please check your email and confirm your account before signing in.',
    userAlreadyExists: 'An account with this email already exists. Please sign in instead.',
    accountDeleted: 'This account has been deleted. You can create a new account with this email address.',
    accountSuspended: 'Your account has been suspended. Please contact support for assistance.',
    accountInactive: 'Your account is inactive. Please verify your email or contact support.',
    passwordTooWeak: 'Password must be at least 6 characters long.',
    tooManyRequests: 'Too many attempts. Please wait a moment before trying again.',
    passwordResetFailed: 'Failed to send password reset email. Please try again.',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    networkError: 'Unable to connect to the server. Please check your internet connection and try again.',
    // Email Verification
    verifyEmailTitle: 'Verify Your Email',
    verificationCodeSent: 'We\'ve sent a verification code to {{email}}',
    verificationInstructions: 'Please enter the 6-digit code we sent to {{email}}',
    verificationCode: 'Verification Code',
    enterSixDigitCode: 'Enter the 6-digit code from your email',
    verifying: 'Verifying...',
    verifyAndCreateAccount: 'Verify & Create Account',
    didntReceiveCode: 'Didn\'t receive the code?',
    resendCode: 'Resend Code',
    resendIn: 'Resend in {{seconds}}s',
    backToSignUp: 'Back to Sign Up',
    verificationSuccess: 'Email verified successfully! Welcome to Safaqat 24.',
    otpResent: 'A new verification code has been sent to your email.',
    resendFailed: 'Failed to resend verification code. Please try again.',
    invalidOtpCode: 'Please enter a valid 6-digit code',
    invalidOrExpiredOtp: 'Invalid or expired verification code. Please try again or request a new code.',
    registrationExpired: 'Registration session expired. Please sign up again.',
    // Two-factor authentication (TOTP)
    twoFactorTitle: 'Two-factor authentication',
    twoFactorSubtitle: 'Enter the 6-digit code from your authenticator app',
    backupCodeTitle: 'Enter backup code',
    backupCodeSubtitle: 'Enter one of your 10-character backup codes',
    verify: 'Verify',
    useBackupCode: 'Use a backup code instead',
    useAuthenticatorApp: 'Use authenticator app instead',
    backToSignIn: 'Back to sign in',
    backupCode: 'Backup code',
    invalidTotpCode: 'That code is incorrect or has expired. Please try again.',
    // Password reset page (/reset-password)
    newPasswordSubtitle: 'Choose a strong new password for your account.',
    newPassword: 'New password',
    updatePassword: 'Update password',
    updatingPassword: 'Updating password...',
    passwordUpdatedTitle: 'Password Updated',
    passwordUpdatedSubtitle: 'Redirecting you to sign in…',
    passwordResetSuccess: 'Password updated. You can now sign in.',
    passwordUpdateFailed: 'We could not update your password. Please try again.',
    resetLinkInvalidSubtitle: 'This link is invalid or has expired.',
    resetLinkInvalidLong: 'The link is incomplete or has expired. Please request a new one from the sign-in page.',
    requestNewLink: 'Request a new link',
    rememberedPassword: 'Remembered your password?',
  },
  language: {
    label: 'Language',
    english: 'English',
    arabic: 'Arabic',
  },
  currency: {
    code: 'SAR',
    short: 'SAR',
    name: 'Saudi Riyal',
  },
  units: {
    sqm: 'sqm',
    sqft: 'sq ft',
    month: 'month',
    year: 'year',
  },
  footer: {
    description:
      'Safaqat 24 curates distinguished residences and premium rentals with tailored advisory for every client.',
    quickLinksTitle: 'Quick Links',
    servicesTitle: 'Services',
    companyTitle: 'Company',
    contactTitle: 'Contact',
    quickLinks: {
      home: 'Home',
      search: 'Search for property',
      map: 'Map View',
      brokersMap: 'Brokers Map',
      trustedBrokers: 'Trusted Brokers',
      marketInsights: 'Market Insights',
      consultation: 'Book Consultation',
      contact: 'Contact Us',
    },
    serviceLinks: {
      listProperty: 'List Your Property',
      membership: 'Membership Plans',
      addons: 'Add-ons',
      bundles: 'Bundles',
      coins: 'Wallet & Coins',
    },
    companyLinks: {
      about: 'About Us',
      contact: 'Contact Us',
      requests: 'Request a Property',
      complaints: 'Submit a Complaint',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
    },
    services: {
      sales: 'Luxury Home Sales',
      management: 'Property Management',
      advisory: 'Investment Advisory',
      corporate: 'Corporate Leasing Solutions',
    },
    address: 'Jeddah',
    phone: '+966 50 560 8271',
    email: 'info@safaqat24.sa',
    liveChat: 'Live Chat Support',
    notice:
      'Safaqat 24 is licensed by the Saudi Real Estate General Authority (REGA). All rights reserved.',
    copyright: 'All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms & Conditions',
  },
  theme: {
    label: 'Theme',
    toggle: 'Toggle theme',
    purple: 'Purple',
    earthy: 'Earthy',
  },
  brokerMap: {
    title: 'Brokers across the Kingdom',
    subtitle: 'Explore individual brokers, companies and developers by where they are based and where they list.',
    searchPlaceholder: 'Search brokers…',
    verifiedOnly: 'Verified only',
    rankBy: 'Rank by',
    topBrokers: 'Top active brokers',
    navLink: 'Brokers Map',
    viewOnMap: 'View on map',
    type: { all: 'All', individual: 'Individuals', company: 'Companies', developer: 'Developers' },
    metric: { listings: 'Listings', engagement: 'Engagement' },
    mode: { reach: 'Reach', listings: 'Listings' },
  },
  // Subscriber-gated /special-deals page. The page already reads these via
  // t('special.*'); before this block existed it fell back to English defaultValues
  // in both languages (so the page rendered English even in Arabic mode).
  special: {
    title: 'Special deals',
    subtitle: 'Exclusive featured listings, available to Safaqat24 subscribers.',
    lockedTitle: 'A subscriber benefit',
    lockedSub: 'Special deals are exclusive to Safaqat24 subscribers. Subscribe to unlock them.',
    lockedGuest: 'Sign in and subscribe to unlock exclusive Safaqat24 special deals.',
    subscribe: 'View subscriptions',
    empty: 'No special deals available right now. Check back soon.',
    loadError: 'Could not load special deals.',
  },
  // Status chips (components/ui/StatusChip.tsx reads t('status.<TOKEN>')). Same
  // wording as the component's own defaults; the block exists so Arabic has keys.
  status: {
    VERIFIED: 'Verified',
    VERIFYING: 'Verifying',
    DECLARED: 'Pending',
    EXPIRING_SOON: 'Expiring soon',
    EXPIRED: 'Expired',
    SUSPENDED: 'Suspended',
    REJECTED: 'Rejected',
    REQUESTED: 'Requested',
    QUOTED: 'Quoted',
    ACCEPTED: 'Accepted',
    IN_PROGRESS: 'In progress',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    PLANNING: 'Planning',
    UNDER_CONSTRUCTION: 'Under construction',
    READY: 'Ready',
    SOLD_OUT: 'Sold out',
  },
  // "Grow your account" (/account/professional). Same wording as the page's own
  // defaults; the block exists so Arabic has keys.
  pro: {
    title: 'Grow your account',
    subtitle: 'Add a licensed professional role to yourself, or register a company you own. Each role is verified by its licence.',
    yourRoles: 'Your professional roles',
    addRole: 'Add a professional role',
    selectRole: 'Select a role…',
    scopeUser: 'For me (individual)',
    scopeCompany: 'For my company',
    displayName: 'Display name (optional)',
    licenseNumber: 'Licence number (to verify now)',
    addRoleBtn: 'Add role',
    registerCompany: 'Register a company',
    registerCompanyHint: 'Create a company you own. You can then add the firm’s licensed activities (brokerage, development, etc.).',
    companyName: 'Company name',
    companyPhone: 'Company phone (optional)',
    registerCompanyBtn: 'Register company',
    disabled: 'Professional roles are not enabled yet.',
    loadError: 'Could not load your professional roles.',
    dupRole: 'You already hold this role.',
    addError: 'Could not add the role.',
    hasCompany: 'You already belong to a company.',
    companyError: 'Could not register the company.',
    type: {
      BROKER: 'Broker & Marketer',
      DEVELOPER: 'Developer',
      INVESTOR: 'Investor',
      CONSULTANT: 'Consultant',
      ANALYST: 'Analyst',
      APPRAISER: 'Appraiser',
      PROPERTY_MANAGEMENT: 'Property Management',
      FACILITIES_MANAGEMENT: 'Facilities Management',
    },
  },
};

export default common;


